import { CHANGE_CALL_PROVIDER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
import { flatten } from './openCallingWidget';
export default function changeCallProvider(data) {
  return callingAPIMethodWithQueue(CHANGE_CALL_PROVIDER, data, flatten);
}